<template>
  <div>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-text-field
            v-model="computedDateFormatted"
            :label="label"
            prepend-inner-icon="mdi-calendar"
            readonly
            filled
            :hide-details="hideDetails"
            :rules="rules"
            :disabled="disabled"
          ></v-text-field>
        </span>
      </template>
      <v-date-picker
        v-model="date"
        :active-picker.sync="activePicker"
        :no-title="noTitle"
        scrollable
        show-adjacent-months
        show-week
        color="primary"
        header-color="date"
        first-day-of-week="1"
        :max="max"
        :min="min"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="$refs.dialog.save(date)">
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <!-- <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="computedDateFormatted"
          :label="label"
          :placeholder="placeholder"
          :prepend-icon="prependIcon"
          :prepend-inner-icon="prependInnerIcon"
          :hide-details="hideDetails"
          :filled="filled"
          :dense="dense"
          :clearable="clearable"
          :readonly="readonly"
          :rules="rules"
          v-bind="attrs"
          v-on="on"
        >
          <template v-slot:prepend-inner>
            <slot name="prepend-inner"></slot>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="date"
        :active-picker.sync="activePicker"
        :max="max"
        :min="min"
        @change="save"
      ></v-date-picker>
    </v-menu> -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    value: {
      required: true,
    },
    label: {
      default: "",
    },
    hideDetails: {
      default: "auto",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noTitle: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      default: null,
    },
    "prepend-icon": {
      default: null,
    },
    "prepend-inner-icon": {
      default: "mdi-calendar",
    },
    "hide-details": {
      default: "auto",
    },
    filled: {
      default: true,
    },
    dense: {
      default: false,
    },
    clearable: {
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
    },
    max: {
      default: new Date().toISOString().substr(0, 10),
    },
    min: {
      default: "1900-01-01",
    },
  },
  data: () => ({
    modal: false,
    // menu: false,
    activePicker: null,
  }),
  watch: {
    // menu(val) {
    //   val && setTimeout(() => (this.activePicker = "YEAR"));
    // },
    modal(val) {
      val && !this.date && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    save(date) {
      // this.$refs.menu.save(date);
      this.$emit("change", date);
    },
  },
  computed: {
    date: {
      get: function () {
        if (this.value) {
          return moment(this.value).format("YYYY-MM-DD");
        }
        return this.value;
      },
      set: function (value) {
        //Convert from YYYY-MM-DD to 2001-02-08T00:00:00+01:00
        var data = value;
        if (value) {
          data = moment(value).format();
        }
        this.$emit("input", data);
      },
    },
    computedDateFormatted: {
      get() {
        if (this.date) {
          return moment(this.date).format("DD.MM.YYYY");
        }
        return this.date;
      },
      set(value) {
        this.data = value;
      },
    },
  },
};
</script>
